import { render, staticRenderFns } from "./colChart.vue?vue&type=template&id=b9011af8&scoped=true&"
import script from "./colChart.vue?vue&type=script&lang=js&"
export * from "./colChart.vue?vue&type=script&lang=js&"
import style0 from "./colChart.vue?vue&type=style&index=0&id=b9011af8&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9011af8",
  null
  
)

export default component.exports